<template>
  <v-container>
    <v-form ref="form" v-model="valid">
      <v-text-field
        :label="$t('entities.unit.props.code')"
        v-model="value.code"
        :rules="$isRequiredRule"
        clearable
        required
      ></v-text-field>
      <v-text-field
        :label="$t('entities.unit.props.description')"
        v-model="value.description"
        :rules="$isRequiredRule"
        clearable
        required
      ></v-text-field>
      <v-select
        :items="$unitTypes"
        v-model="value.type"
        :label="$t('entities.unit.props.type')"
        clearable
      />
    </v-form>
  </v-container>
</template>
<script>
export default {
  props: {
    value: {
      default() {
        return {
          code: "",
          description: ""
        };
      }
    }
  },
  data() {
    return {
      valid: false
    };
  },
  watch: {
    value(){
      this.$refs.form.resetValidation();
    }
  },
  methods: {
    isValid() {
      let form = this.$refs.form;
      return form.validate();
    }
  }
};
</script>